import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IProcess, IProcessInitial } from "./processModel";
import {
  createProcess,
  deleteProcess,
  findAllActiveProcess,
  getAllProcess,
  getItemProcessById,
  ProcessActiveInactive,
  updateProcess,
} from "./services/process.services";

const initialState: IProcessInitial = {
  loading: false,
  formLoading: false,
  error: "",
  ProcessList: [],
  ProcessID: null,
  ProcessDetail: {
    process_name: "",
    parent_process_id: null,
    parent_process: "",
    remarks: "",
    isactive: 1,
  },
};

export const processSlice = createSlice({
  name: "process",
  initialState,
  reducers: {
    clearProcessDetails: (state) => {
      state.ProcessDetail = initialState.ProcessDetail;
    },
    setProcessID: (state, action) => {
      state.ProcessID = action.payload;
    },
    clearProcessID: (state) => {
      state.ProcessID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllProcess.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllProcess.fulfilled,
      (state, action: PayloadAction<IProcess[]>) => {
        state.loading = false;
        state.ProcessList = action.payload;
      }
    );
    builder.addCase(getAllProcess.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ProcessList = [];
    });

    builder.addCase(findAllActiveProcess.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActiveProcess.fulfilled,
      (state, action: PayloadAction<IProcess[]>) => {
        state.loading = false;
        state.ProcessList = action.payload || [];
      }
    );
    builder.addCase(findAllActiveProcess.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.ProcessList = [];
    });

    builder.addCase(createProcess.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createProcess.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createProcess.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateProcess.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateProcess.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateProcess.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteProcess.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteProcess.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteProcess.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(ProcessActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ProcessActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ProcessActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getItemProcessById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getItemProcessById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.ProcessDetail = action.payload;
    });
    builder.addCase(getItemProcessById.rejected, (state, action) => {
      state.formLoading = false;
      state.ProcessDetail = initialState.ProcessDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearProcessDetails, setProcessID, clearProcessID } =
  processSlice.actions;
export default processSlice.reducer;
